import React from "react";
import Banner from "../components/bridesmaids/banner";
import Maids from "../components/bridesmaids/maids";
import GalFooter from "../components/gallery/gallery-footer";

function BrideMaids() {
  return (
    <>
      <Banner />
      <Maids />
      <GalFooter />
    </>
  );
}

export default BrideMaids;
